import { render, staticRenderFns } from "./memberLinkageTab.vue?vue&type=template&id=12fe7f59&lang=pug"
import script from "./memberLinkageTab.vue?vue&type=script&lang=js"
export * from "./memberLinkageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports